export enum AutocompleteVehiclesBy {
  LICENSE_PLATE = "LICENSE_PLATE",
  VIN = "VIN",
}

export enum AutocompleteRequestOrigin {
  CALC = "CALC",
  CONTRACT = "CONTRACT",
  // Searches only vehicles already stored in our database, external sources are skipped
  GENERIC_CONTRACT = "GENERIC_CONTRACT",
}
